// src/App.js
import React from "react";
import { BrowserRouter as Router, Route, Routes, Navigate } from "react-router-dom";

// Pages
import Login from "./pages/Login";
import SignalsDashboard from "./pages/SignalsDashboard";
import MarketSnapshot from "./pages/MarketSnapshot";
import FixedIncomeView from "./pages/FixedIncomeView";
import TradeComplianceHistory from "./pages/TradeComplianceHistory";
import PortfolioView from "./pages/PortfolioView";
import EconomicDashboard from "./pages/EconomicDashboard";
import ScreenerView from "./pages/ScreenView";
import RiskDashboard from "./pages/RiskDashboard";
import TradingDesk from "./pages/TradingDesk";

// Components
import PrivateRoute from "./components/PrivateRoute";

// Redirect root path "/" → /leaps
const LandingRedirect = () => <Navigate to="/leaps" replace />;

function App() {
  return (
    <Router>
      <Routes>
        {/* Public login route */}
        <Route path="/login" element={<Login />} />

        {/* Default route */}
        <Route path="/" element={<LandingRedirect />} />

        {/* Auth-protected routes */}
        <Route
          path="/leaps"
          element={
            <PrivateRoute>
              <SignalsDashboard />
            </PrivateRoute>
          }
        />
        <Route
          path="/screener"
          element={
            <PrivateRoute>
              <ScreenerView />
            </PrivateRoute>
          }
        />
        <Route
          path="/history"
          element={
            <PrivateRoute>
              <TradeComplianceHistory />
            </PrivateRoute>
          }
        />
        <Route
          path="/market"
          element={
            <PrivateRoute>
              <MarketSnapshot />
            </PrivateRoute>
          }
        />
        <Route
          path="/fixed-income"
          element={
            <PrivateRoute>
              <FixedIncomeView />
            </PrivateRoute>
          }
        />
        <Route
          path="/trading-desk"
          element={
            <PrivateRoute>
              <TradingDesk />
            </PrivateRoute>
          }
        />
        <Route
          path="/portfolio"
          element={
            <PrivateRoute>
              <PortfolioView />
            </PrivateRoute>
          }
        />
        <Route
          path="/economics"
          element={
            <PrivateRoute>
              <EconomicDashboard />
            </PrivateRoute>
          }
        />
        {/* NEW: Risk Dashboard */}
        <Route
          path="/risk"
          element={
            <PrivateRoute>
              <RiskDashboard />
            </PrivateRoute>
          }
        />
      </Routes>
    </Router>
  );
}

export default App;
